
export class GCoordinate {
    latitude: number;
    longitude: number;
}